import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { ErrorMessage, Field } from "formik";
import Select from "react-select";
import { ReactSelectBootstrapStyle } from "../../../styles/ReactSelectBootstrapStyle";

interface TaskBasicFieldsProps {
  errors: any;
  touched: any;
  setFieldValue: (field: string, value: any) => void;
  setTaskTypeId: (id: string) => void;
  allTaskTypes: any[];
  taskTypeRecord: any;
  allUsers: any[];
  currentUser: any;
}

export const TaskBasicFields: React.FC<TaskBasicFieldsProps> = ({
  errors,
  touched,
  setFieldValue,
  setTaskTypeId,
  allTaskTypes,
  taskTypeRecord,
  allUsers,
  currentUser,
}) => (
  <>
    <Form.Group as={Row} className="mb-3" controlId="taskTaskName">
      <Form.Label column sm={3}>
        Task Name <span style={{ color: 'red' }}>*</span>
      </Form.Label>
      <Col sm={9}>
        <Field name="name" type="text" className={"form-control" + (errors.name && touched.name ? " is-invalid" : "")} />
        <ErrorMessage name="name" component="div" className="invalid-feedback" />
      </Col>
    </Form.Group>

    <Form.Group as={Row} className="mb-3" controlId="taskTaskTypeId">
      <Form.Label column sm={3}>
        Type <span style={{ color: 'red' }}>*</span>
      </Form.Label>
      <Col sm={9}>
        <Select
          styles={ReactSelectBootstrapStyle}
          className="stateManagedSelect"
          onChange={(value) => {
            setTaskTypeId(value?.value || "");
            setFieldValue("taskTypeId", value?.value || "");
          }}
          isClearable
          options={allTaskTypes}
        />
        <ErrorMessage name="taskTypeId" component="div" className="invalid-feedback" />
      </Col>
    </Form.Group>

    {taskTypeRecord && (
      <>
        {taskTypeRecord.personnel && (
          <Form.Group as={Row} className="mb-3" controlId="taskUserId">
            <Form.Label column sm={3}>
              Personnel <span style={{ color: 'red' }}>*</span>
            </Form.Label>
            <Col sm={9}>
              <Select
                isMulti
                styles={ReactSelectBootstrapStyle}
                className="stateManagedSelect"
                onChange={(value) => {
                  const identityIds = value?.map(v => v.value) || [];
                  setFieldValue("userId", identityIds);
                }}
                defaultInputValue={`${currentUser?.identity.displayName}: ${currentUser?.identity.email}`}
                isClearable
                options={allUsers}
              />
              <ErrorMessage name="userId" component="div" className="invalid-feedback" />
            </Col>
          </Form.Group>
        )}

        {taskTypeRecord.location && (
          <Form.Group as={Row} className="mb-3" controlId="taskLocation">
            <Form.Label column sm={3}>
              Location
            </Form.Label>
            <Col sm={9}>
              <Field name="location" type="text" className={"form-control" + (errors.location && touched.location ? " is-invalid" : "")} />
              <ErrorMessage name="location" component="div" className="invalid-feedback" />
            </Col>
          </Form.Group>
        )}
      </>
    )}
  </>
);
